import { useMemo } from 'react';
import { ColumnDef, createColumnHelper, SortingFn } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { SurveyAnswerDto } from '@families-link/shared';
import { UnrecognizedSurveyAnswersTableHandlers } from '../../components/family-details/families-details-table/families-unrecognized-answers-table.component';
import { UnrecognizedAnswersTableActions } from '../../components/family-details/families-details-table/families-unrecognized-answers-table-actions.component';
const helper = createColumnHelper<SurveyAnswerDto & { createdAt: string; updatedAt: string }>();

export function useUnrecognizedSurveyAnswersTableColumns(
	handlers: UnrecognizedSurveyAnswersTableHandlers
): ColumnDef<SurveyAnswerDto, string>[] {
	const { onAttachFamily, onDelete, onView } = handlers;

	const [t] = useTranslation();

	const stringValueSort: SortingFn<any> = (rowA, rowB, columnId) => {
		const a = rowA.getValue<string>(columnId) || '';
		const b = rowB.getValue<string>(columnId) || '';

		const collator = new Intl.Collator(undefined, {
			numeric: true,
			sensitivity: 'base',
		});

		return collator.compare(a, b);
	};

	const result = useMemo(
		() => [
			helper.accessor('fullName', {
				header: t('families.columns.full-name'),
				meta: {
					flex: 1,
				},
				enableSorting: true,
				sortingFn: stringValueSort,
				cell: ({ row }) => row.original.fullName

			}) as ColumnDef<SurveyAnswerDto, string>,
			helper.accessor('phoneNumber', {
				header: t('families.columns.phone-number'),
				meta: {
					flex: 1,
				},
				enableSorting: true,
				sortingFn: stringValueSort,
				cell: ({ row }) => {
					const phoneNumber = row.original.phoneNumber;

					return `${phoneNumber?.slice(0, 2)} (${phoneNumber?.slice(2, 5)}) ${phoneNumber?.slice(
						5,
						8
					)}-${phoneNumber?.slice(8, 12)}`;
				},
			}) as ColumnDef<SurveyAnswerDto, string>,
			helper.display({
				id: 'actions',
				cell: (props) => (
					<UnrecognizedAnswersTableActions
						surveyAnswer={props.row.original}
						onAttachFamily={onAttachFamily}
						onDelete={onDelete}
						onView={onView}
					/>
				),
			}) as ColumnDef<SurveyAnswerDto>,
		],
		[t, onAttachFamily, onDelete, onView]
	);

	return result;
}
